// Content-set id from the catalog; default thematic Factors tab for new dashboards.
export const DEFAULT_FACTORS_THEMATIC_CONTENT_SET_ID = "GLOBAL_THEMATIC_BETAS_63D_IDIO"
